// Unique hero images for the national DSCR cluster pages (SEO: no duplicate og:image across pages).
import rates from "@/assets/hero-dscr-cluster/dscr-loan-rates.jpg.asset.json";
import requirements from "@/assets/hero-dscr-cluster/dscr-loan-requirements.jpg.asset.json";
import cashOut from "@/assets/hero-dscr-cluster/dscr-cash-out-refinance.jpg.asset.json";
import rateTerm from "@/assets/hero-dscr-cluster/dscr-rate-term-refinance.jpg.asset.json";
import heloc from "@/assets/hero-dscr-cluster/dscr-heloc-corrected.png";
import noRatio from "@/assets/hero-dscr-cluster/no-ratio-dscr-loans.jpg";
import prosCons from "@/assets/hero-dscr-cluster/dscr-loan-pros-and-cons.jpg.asset.json";
import howItWorks from "@/assets/hero-dscr-cluster/how-dscr-works.jpg.asset.json";
import interestOnly from "@/assets/hero-dscr-cluster/interest-only-dscr-loans.jpg.asset.json";
import secondLien from "@/assets/hero-dscr-cluster/dscr-second-lien-heloc.jpg";


export type ClusterHero = { src: string; alt: string };

export const dscrClusterHeroes: Record<string, ClusterHero> = {
  "/dscr-loan-rates": {
    src: rates.url,
    alt: "Single-family rental home at dusk with a rate sheet and calculator on a porch table — current DSCR loan rates for investors",
  },
  "/dscr-loan-requirements": {
    src: requirements.url,
    alt: "Suburban rental duplex with an underwriting checklist on the front steps — DSCR loan requirements for rental property investors",
  },
  "/dscr-cash-out-refinance": {
    src: cashOut.url,
    alt: "Rental house at dusk with closing documents and keys in the foreground — DSCR cash-out refinance to pull equity from a rental",
  },
  "/dscr-rate-term-refinance": {
    src: rateTerm.url,
    alt: "Two-story rental home on a quiet street at blue hour with refinance paperwork on a desk — DSCR rate and term refinance",
  },
  "/dscr-heloc": {
    src: heloc,
    alt: "Investor reviewing a line-of-credit statement at a home desk overlooking a rental property — investment property HELOC on a DSCR basis",
  },
  "/no-ratio-dscr-loans": {
    src: noRatio,
    alt: "Vacant freshly painted rental house with a for-rent sign in the yard — No-Ratio DSCR loan for properties without rent coverage",
  },
  "/dscr-loan-pros-and-cons": {
    src: prosCons.url,
    alt: "Two rental homes side by side, one in sun and one in shade — weighing DSCR loan pros and cons",
  },
  "/how-dscr-works": {
    src: howItWorks.url,
    alt: "Brick townhome rental at sunrise with handwritten rent-versus-payment math on a notepad — how DSCR is calculated",
  },
  "/interest-only-dscr-loans": {
    src: interestOnly.url,
    alt: "Rental fourplex in late-afternoon light with an amortization schedule on a patio table — interest-only DSCR loan cash flow",
  },
  "/dscr-second-lien-heloc": {
    src: secondLien,
    alt: "Rental house in warm light with a HELOC statement and second-lien mortgage agreement on a desk — DSCR second-lien HELOC on investment property",
  },
};

export function getDscrClusterHero(path: string): ClusterHero | undefined {
  return dscrClusterHeroes[path];
}
